import React, { useState } from "react";

/**
 * Per-server update dialog: lets an operator pick exactly which versions to push to one server,
 * pre-filled with the current targets. Needed because the resolved target can be set too high by
 * mistake - this allows pushing a specific (including lower) version to recover.
 */
export default function ServerUpdateDialog({ server, onApply, onClose }) {
  const [ho, setHo] = useState(server?.targetHoVersion || "");
  const [ds, setDs] = useState(server?.targetDsVersion || "");
  const [ss, setSs] = useState(server?.targetSsVersion || "");
  const [busy, setBusy] = useState(false);

  const label = server?.displayName || server?.groupName || server?.serverId;

  const rows = [
    { key: "ho", caption: "HeadOfficeV2", installed: server?.hoVersion, value: ho, set: setHo },
    { key: "ds", caption: "DataServices", installed: server?.dsVersion, value: ds, set: setDs },
    { key: "ss", caption: "ServerService", installed: server?.ssVersion, value: ss, set: setSs },
  ];

  const handleApply = async () => {
    setBusy(true);
    try {
      await onApply({ targetHoVersion: ho, targetDsVersion: ds, targetSsVersion: ss });
      onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="portal-panel"
        style={{ width: "520px", maxWidth: "92vw", padding: "20px", background: "var(--content-bg)", borderRadius: "var(--radius-md)" }}
      >
        <h2 style={{ margin: "0 0 4px 0", fontSize: "18px" }}>Update Server</h2>
        <p style={{ margin: "0 0 16px 0", color: "var(--text-muted)", fontSize: "var(--fs-xs)" }}>
          {label} &mdash; choose the versions to push. Leave a field blank to skip that component.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {rows.map((r) => (
            <div key={r.key} style={{ display: "grid", gridTemplateColumns: "1fr 110px 1fr", gap: "10px", alignItems: "center" }}>
              <label style={{ fontSize: "13px", fontWeight: 600 }}>{r.caption}</label>
              <span style={{ fontSize: "var(--fs-xs)", color: "var(--text-muted)" }}>
                installed: {r.installed || "-"}
              </span>
              <input
                className="toolbar-input"
                value={r.value}
                onChange={(e) => r.set(e.target.value)}
                placeholder="e.g. 1.2.3.4"
                style={{
                  padding: "6px 10px", borderRadius: "4px",
                  border: "1px solid var(--border-color)",
                  background: "var(--input-bg)", color: "var(--text-color)",
                }}
              />
            </div>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "20px" }}>
          <button
            onClick={onClose}
            disabled={busy}
            style={{ padding: "8px 14px", borderRadius: "4px", cursor: "pointer", background: "transparent", color: "var(--text-color)", border: "1px solid var(--border-color)" }}
          >
            Cancel
          </button>
          <button
            onClick={handleApply}
            disabled={busy}
            style={{ padding: "8px 14px", borderRadius: "4px", cursor: "pointer", background: "var(--brand-mid)", color: "white", border: "none" }}
          >
            {busy ? "Sending..." : "Push Update"}
          </button>
        </div>
      </div>
    </div>
  );
}
